<template>
  <div>
    <loading-screen v-if="isLoading" />
    <div class="p-6 text-gray-900 bg-white rounded-lg text-left font-medium shadow-lg">
      <h1 class="font-semibold text-xl">
        <fa-icon
          :icon="['fas', 'key']"
          size="lg"
          class="mr-1 text-blue-400"
        />
        {{ $t("Projects", "Projects") }}
      </h1>
      <div class="mx-64 mt-4 p-4 text-blue-400 bg-blue-100 rounded-lg border border-blue-400 flex items-center">
        <div>
          <fa-icon
            :icon="['fal', 'info-circle']"
            size="lg"
            class="mr-4 text-blue-400"
          />
        </div>
        <div>
          These keys are used to access Text Analysis API. Do not share your keys, treat your secret API keys as you would any other password.
        </div>
      </div>
      <div class="mx-64 my-4">
        <div
          v-for="project in projects.projects"
          :key="project.id"
        >
          <project-box
            :project="project"
            @edit="isPopupShown = true; editedProjectId = project.id;"
          />
        </div>
        <div
          class="m-auto w-1/2 cursor-pointer text-center text-blue-500"
          @click="isPopupShown = true"
        >
          <fa-icon
            :icon="['fal', 'plus-circle']"
            size="lg"
            class="mr-2"
          />
          Add new Project
        </div>
      </div>
    </div>
    <project-popup
      v-if="isPopupShown"
      :initial-name="editedProjectName"
      @saved="submit"
      @close="isPopupShown = false; editedProjectId = null;"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { actionNames } from '@/store'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faInfoCircle, faPlusCircle } from '@fortawesome/pro-light-svg-icons'
import { faKey } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import ProjectBox from './components/ProjectBox'
import ProjectPopup from '@/projects/components/ProjectPopup'
import LoadingScreen from '@/global/ui/LoadingScreen'

library.add(faInfoCircle, faPlusCircle, faKey)
export default {
  name: 'Projects',
  components: {
    'fa-icon': FontAwesomeIcon,
    ProjectBox,
    ProjectPopup,
    LoadingScreen
  },
  data () {
    return {
      isPopupShown: false,
      editedProjectId: null,
      isLoading: false
    }
  },
  computed: {
    ...mapState(['projects']),
    editedProjectName () {
      const editedProject = this.projects.projects.find(p => p.id === this.editedProjectId)
      return editedProject ? editedProject.name : null
    }
  },
  mounted () {
    this.isLoading = true
    this.$store.dispatch(actionNames.INIT_PROJECTS)
    this.isLoading = false
  },
  methods: {
    submit (name) {
      if (this.editedProjectId) {
        this.$store.dispatch(actionNames.RENAME_PROJECT, { name, projectId: this.editedProjectId })
      } else {
        this.$store.dispatch(actionNames.CREATE_PROJECT, name)
      }
      this.isPopupShown = false
      this.editedProjectId = null
    }
  }
}
</script>
